import { getQueriedUrl } from 'src/common/utils/utilities';
import type {
  DeliveryRequestDetailParams,
  HomeRouteParams,
  PaymentRouteParams,
  PreviewFirstPreviewRouteParams,
} from 'src/router/types';

const getPathTo = {
  previewFirstNewRequest: {
    sender: () => `/new-request/preview-first/sender`,
    receiver: () => `/new-request/preview-first/receiver`,
    preview: (params?: PreviewFirstPreviewRouteParams) => getQueriedUrl('/new-request/preview-first/preview', params ?? {}),
    checkout: () => `/new-request/preview-first/checkout`,
  },
  login: () => `/auth/login`,
  SSOLogin: () => `/auth/sso/redirect`,
  SSOCallback: () => `/auth/sso/callback`,
  confirm: (phoneNumber: string) => `/auth/confirm/${phoneNumber}`,
  signUp: () => `/auth/sign-up`,
  home: (params?: HomeRouteParams) => getQueriedUrl('/home', params ?? {}),
  deliveryRequestDetail: (id: string, params?: DeliveryRequestDetailParams) =>
    getQueriedUrl(`/delivery-request/${id}`, params ?? {}),
  addReceiver: (id: string) => `/delivery-request/${id}/add-receiver`,
  editReceiver: (id: string, receiverIndex: number) => `/delivery-request/${id}/edit-receiver/${receiverIndex}`,
  newDeliveryRequestSender: () => `/new-request/sender`,
  newDeliveryRequestReceiver: () => `/new-request/receiver`,
  newDeliveryRequestPreview: (extra?: Record<string, string>) => {
    if (!extra || Object.keys(extra).length === 0) return `/new-request/preview`;
    return getQueriedUrl('/new-request/preview', extra);
  },
  nps: (id: string) => `/nps/${id}`,
  payment: (id?: string, params?: PaymentRouteParams) => getQueriedUrl(`/payment/${id}`, params ?? {}),
  paymentGateway: () => `/payment-gateway`,
  viewTrackLink: (token?: string) => `/track/${token}`,
  history: () => `/history`,
  historyDetail: (id: string) => `/history/${id}`,
  discount: () => `/discount`,
  support: () => `https://app.tapsi.cab/products/support`,
  menu: () => '/menu',
  termsAndCondition: () => '/menu/tac',
  smeForm: () => '/menu/sme-form',
  contact: () => '/contact',
  newContact: () => '/contact/new',
  editContact: () => '/contact/edit',
  tiles: () => '/tiles',
};

export default Object.freeze(getPathTo);
